import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment'
import BColor from '../BColor'

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.background.default,
        // },
    },
}))(TableRow);

function createData(ymd, diff, macd, osc, ema12, ema26) {
    return { ymd, diff, macd, osc, ema12, ema26 };
}


const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 250,
      backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000"
    },
    button1: {
      minWidth: 110,
    }
  }));

export default function MACDList(props) {
    const classes = useStyles();
    const [buyselldata, setBuyselldata] = React.useState([]);

    useEffect(() => {
        if (props.open) fectchStockData(props.stockId, props.tp)
    }, [props.stockId, props.tp]);


    function fectchStockData(stockId, tp) {
        if (stockId != null) {
            let a = {
                sid: stockId,
                tp: tp,
                inp: {}
            };

            if (localStorage.getItem('e12') != null && localStorage.getItem('e12') != 12)
                a.inp["e12"] = parseInt(localStorage.getItem('e12'))
            if (localStorage.getItem('e26') != null && localStorage.getItem('e26') != 26)
                a.inp["e26"] = parseInt(localStorage.getItem('e26'))
            if (localStorage.getItem('e9') != null && localStorage.getItem('e9') != 9)
                a.inp["e9"] = parseInt(localStorage.getItem('e9'))


            fetch("/jstock/v1/stock/macd", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        let dd = result.macd.map(row =>
                            createData(moment(row.ymd, "YYYYMMDD").format('YYYY/MM/DD'),
                                row.diff, row.macd, row.osc, row.ema12, row.ema26)
                        )
                        setBuyselldata(dd)
                    },
                    error => {
                    }
                );
        }
    }


    const renderInpriceStatusV = (value) => {
        if (value > 0) {
            return <Button size="small" style={{ minWidth: 90, background: BColor.upcolorbox, color: '#FFFFFF' }} className={classes.button1} >
                {value}
            </Button>
        } else if (value < 0) {
            return <Button size="small" style={{ minWidth: 90, background: BColor.downcolorbox, color: '#FFFFFF' }} className={classes.button1}>
                {value}
            </Button>
        } else {
            return <Button size="small" variant="outlined" style={{ minWidth: 90, color: BColor.faircolor }} className={classes.button1} >
                {value}
            </Button>
        }
    }

    const renderInpriceStatusV1 = (value) => {
        if (value > 0) {
            return <div size="small" variant="outlined" style={{ minWidth: 90, color: BColor.upcolorbox }} className={classes.button1} >
                {value}
            </div>
        } else if (value < 0) {
            return <div size="small" variant="outlined" style={{ minWidth: 90, color: BColor.downcolorbox }} className={classes.button1}>
                {value}
            </div>
        } else {
            return <div size="small" variant="outlined" style={{ minWidth: 90, color: BColor.faircolor }} className={classes.button1} >
                {value}
            </div>
        }
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{props.stockname} MACD</DialogTitle>

            <DialogContent>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table" size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>日期</StyledTableCell>
                                {/* <StyledTableCell align="center">EMA12</StyledTableCell>
                                <StyledTableCell align="center">EMA26</StyledTableCell> */}
                                <StyledTableCell align="center">DIF</StyledTableCell>
                                <StyledTableCell align="center">MACD</StyledTableCell>
                                <StyledTableCell align="center">OSC</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyselldata.map(row => (
                                <StyledTableRow key={row.ymd}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.ymd}
                                    </StyledTableCell>
                                    {/* <StyledTableCell >
                                    {row.ema12}
                                    </StyledTableCell>
                                    <StyledTableCell >
                                    {row.ema26}
                                    </StyledTableCell> */}
                                    <StyledTableCell  align="center">
                                        {renderInpriceStatusV1(row.diff)}
                                    </StyledTableCell>
                                    <StyledTableCell  align="center">
                                        {renderInpriceStatusV1(row.macd)}
                                    </StyledTableCell>
                                    <StyledTableCell  align="center">
                                        {renderInpriceStatusV(row.osc)}
                                    </StyledTableCell>



                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={props.handleClose} color="primary">
                    取消
          </Button> */}
                <Button onClick={props.handleClose} color="primary">
                    關閉
          </Button>
            </DialogActions>
        </Dialog>
    );
}